import { createSvgIcon } from '@material-ui/core/utils';

export const DpGraphIcon = createSvgIcon(
  <>
    <rect
      width="12.98"
      height="12.98"
      x="1.37"
      y="2.26"
      rx="6.49"
      ry="6.49"
      transform="rotate(-180 7.86 8.75)"
    />
    <rect
      width="8.74"
      height="8.74"
      x="13.89"
      y="11.01"
      rx="4.37"
      ry="4.37"
      transform="rotate(180 18.26 15.385)"
    />
    <rect
      width="5.62"
      height="5.62"
      x="7.86"
      y="16.12"
      rx="2.81"
      ry="2.81"
      transform="rotate(180 10.67 18.93)"
    />
    <rect
      width="4.12"
      height="4.12"
      x="15.91"
      y="5.18"
      rx="2.06"
      ry="2.06"
      transform="rotate(180 17.97 7.245)"
    />
  </>,
  'DpGraphIcon',
);
